export default __webpack_public_path__ + "static/media/deny~FCuGuVDQ.a59bcadd.gif";